<template>
    <div class="audioContainer ">
        <div class="duration">{{ timePassed != '0.00' ? timePassed : message?.content?.audio?.duration }}</div>
        <div v-show="audioReady" ref="audioContainer"></div>
        <img v-if="!audioReady" :src="loadFile(images.wave)" height="40" class="w-1oo">
        <img v-show="!audioLoading" @click="playPauseAudio" :src="loadFile(images[audioPlaying ? 'pause' : 'play'])"
            height="36" width="36">
        <span v-if="audioLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import WaveSurfer from 'wavesurfer.js'
import lodash from 'lodash'
import { loadFile, fetchAudioMetadata, formatTimeDuration } from '@/components/utils.js'
import { useStore } from 'vuex';

const props = defineProps({
    message: {
        type: Object,
        default: () => ({}),
        required: true,
    },
});

const store = useStore();

const audioContainer = ref(null);
const audioPlaying = ref(false)
const audioLoading = ref(false)
const audioReady = ref(false)
const timePassed = ref('0.00')

let wavesurfer = null
const images = {
    play: 'play.svg',
    pause: 'pause.svg',
    wave: 'wave.svg'
}
const playPauseAudio = () => {
    if (!audioReady.value) {
        // wavesurfer.load(`${window.location.origin}/assets/test.mp3`);
        const urlAudio = `${props.message.content.audio.url}`;
        wavesurfer.load(`${urlAudio}`);
        audioLoading.value = true
        return
    }
    wavesurfer.playPause()
}
const formatTime = (duration) => {
    const minutes = Math.floor(duration / 60);
    const remainingSeconds = Math.floor(duration % 60);
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
}
const throttledLeftTime = lodash.throttle(() => {
    timePassed.value = formatTime(wavesurfer.getCurrentTime());
}, 1001);
const initialWaveSurfer = () => {
    wavesurfer = WaveSurfer.create({
        container: audioContainer.value,
        waveColor: "#6D6D6D",
        progressColor: "#ec552f",
        barWidth: 3,
        barGap: 4,
        normalize: true,
        responsive: true,
        barRadius: 5,
        duration: null,
        width: 190,
        height: 40,
        cursorColor: 'transparent',
        cursorWidth: 0,
        xhr: {
            cache: "default",
            mode: "cors",
            method: "GET",
            credentials: "include",
            headers: [
                { key: "cache-control", value: "no-cache" },
                { key: "pragma", value: "no-cache" }
            ]
        }
        // url: `${window.location.origin}/assets/test.mp3`,
    });
    wavesurfer.on('play', () => {
        audioPlaying.value = true
    })
    wavesurfer.on('finish', () => {
        audioPlaying.value = false
    })
    wavesurfer.on('pause', () => {
        audioPlaying.value = false
    })
    wavesurfer.on('ready', () => {
        audioLoading.value = false
        audioReady.value = true
        playPauseAudio()
    });
    wavesurfer.on('audioprocess', throttledLeftTime);
}
onMounted(async () => {
    initialWaveSurfer();
    if (props?.message?.content?.audio?.duration == undefined) {
        const audioUrl = props?.message?.content?.audio?.url
        const duration = await fetchAudioMetadata(audioUrl)
        const updatedMessage = { ...props.message }
        updatedMessage.content.audio.duration = formatTimeDuration(duration ?? 0)
        store.commit('Chat/updateMessage', updatedMessage);
    }

})
</script>

<style scoped lang="scss">
@import './styles/audio.scss';
</style>
